
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M6 5.5H1.5m14 0h-2m-2.5 6h4.5m-14 0h2M8 5.508a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m1 5.971a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"}})])
          )
        }
      }
    